
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Top 5 erreurs à éviter pour vos campagnes Instagram Ads",
    description:
      "Évitez les erreurs fréquentes qui freinent vos campagnes Instagram Ads. Découvrez nos conseils et bénéficiez de l'expertise d’ALEO pour maximiser vos résultats.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
